import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class ConsultaPostulacionesService 
{
    constructor(public http: HttpClient, ) { }

    traePostulantes(rut: any)
    {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`, 
               { headers: this.armaCabecera() }).toPromise();
    }
  
    traeDataRechazo(id: any)
    {
        return this.http.get(`${environment.urlBase}/detalleRechazo/id/${id}`, 
               { headers: this.armaCabecera() }).toPromise();
    }

    traeDataPagada(id: any)
    {
        return this.http.get(`${environment.urlBase}/detallePago/id/${id}`, 
               { headers: this.armaCabecera() }).toPromise();
    }

    traeDataRechazoCompania(id: any)
    {
        return this.http.get(`${environment.urlBase}/detalleRechazoPorCompannia/id/${id}`, 
               { headers: this.armaCabecera() }).toPromise();
    }
    
    armaCabecera()
    {
        return new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
}